module.exports = __webpack_public_path__ + "img/profile_icon.9a56c1d1.svg";